import { Route, Routes } from 'react-router-dom-latest';
import { LoaderOverlay } from '@common-components';
import { BrandingMode } from 'enums';
import { QuoteComparisonInsightsRoutes } from 'broker/broker-routes';
import { useBrandConfigByMode } from 'broker/pages/SubmissionWorkspacePage/contexts/BrandConfigProvider';
import useSubmissionsWorkspace from 'broker/pages/SubmissionWorkspacePage/store/useSubmissionWorkspace';
import Compose from './formSteps/Compose';
import ComposeFromDraft from './formSteps/Compose/ComposeFromDraft';
import Upload from './formSteps/Upload';
import { QuoteComparisonProps } from './types';

export default function QuoteComparisonSteps({
  setIsDirty,
  setInsightPopulatedByAI,
  quotes,
  expiringPolicyFileId,
  pdfGenerationStatus,
  setPdfGenerationStatus,
  quoteComparisonFileId,
  setQuoteComparisonFileId,
  savedDraft,
  brandingMode,
}: Omit<QuoteComparisonProps, 'currentStep'>) {
  const { partialSubmission: submission } = useSubmissionsWorkspace();
  const { brandConfig, isLoading: loadingBrandConfig } = useBrandConfigByMode(
    brandingMode || BrandingMode.Organization,
  );

  return (
    <Routes>
      <Route
        path={`${QuoteComparisonInsightsRoutes.Compose}/*`}
        element={
          savedDraft ? (
            <ComposeFromDraft quotes={quotes} expiringPolicyFileId={expiringPolicyFileId} savedDraft={savedDraft} />
          ) : (
            <Compose
              quotes={quotes}
              setInsightPopulatedByAI={setInsightPopulatedByAI}
              expiringPolicyFileId={expiringPolicyFileId}
            />
          )
        }
      />
      <Route
        path={`${QuoteComparisonInsightsRoutes.Upload}/*`}
        element={
          loadingBrandConfig || !brandConfig ? (
            <LoaderOverlay hideOverlay />
          ) : (
            <Upload
              setIsDirty={setIsDirty}
              pdfGenerationStatus={pdfGenerationStatus}
              setPdfGenerationStatus={setPdfGenerationStatus}
              quotes={quotes}
              submission={submission!}
              quoteComparisonFileId={quoteComparisonFileId}
              setQuoteComparisonFileId={setQuoteComparisonFileId}
              brandConfig={brandConfig}
            />
          )
        }
      />
    </Routes>
  );
}
